import { styled as o, excludeProps as d, modifier as i, css as t } from "@lokalise/styled";
import { value as r } from "../../utils/theme/index.js";
const a = o.div.withConfig({
  shouldForwardProp: d(["height", "width", "centered"])
})`
	height: ${({ height: e }) => e}px;
	width: ${({ width: e }) => typeof e == "string" ? e : `${e}px`};
	border-radius: ${r("radius.m")};
	background-color: ${r("color.background.disabled")};
	${i(
  "centered",
  t`
			margin: 0 auto;
		`
)};
`;
a.displayName = "Rectangle";
export {
  a as Rectangle
};
//# sourceMappingURL=Rectangle.js.map
